import { render, staticRenderFns } from "./list-3.vue?vue&type=template&id=1d0ebfcc&scoped=true"
import script from "./list-3.vue?vue&type=script&lang=js"
export * from "./list-3.vue?vue&type=script&lang=js"
import style0 from "./list-3.vue?vue&type=style&index=0&id=1d0ebfcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ebfcc",
  null
  
)

export default component.exports